import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EoBaseFormControlComponent } from './form/eo-base-form-control/eo-base-form-control.component';
import { EoCountryDropdownComponent } from './form/eo-country-dropdown/eo-country-dropdown.component';
import { EoDatePickerComponent } from './form/eo-date-picker/eo-date-picker.component';
import { EoDropdownComponent } from './form/eo-dropdown/eo-dropdown.component';
import { EoAutoCompleteComponent} from './form/eo-autocomplete/eo-autocomplete.component';
import { EoFileUploadAdvancedComponent } from './form/eo-file-upload-advanced/eo-file-upload-advanced.component';
import { EoFileUploadBaseComponent } from './form/eo-file-upload-base/eo-file-upload-base.component';
import { EoFileUploadComponent } from './form/eo-file-upload/eo-file-upload.component';
import { EoFormPanelComponent } from './form/eo-form-panel/eo-form-panel.component';
import { EoFormComponent } from './form/eo-form/eo-form.component';
import { EoInputComponent } from './form/eo-input/eo-input.component';
import { EoPickListComponent } from './form/eo-pick-list/eo-pick-list.component';
import { EoSpecialtyDropdownComponent } from './form/eo-specialty-dropdown/eo-specialty-dropdown.component';
import { EoUserDropdownComponent } from './form/eo-user-dropdown/eo-user-dropdown.component';
import { EoFormHelpMsgComponent } from './form/shared/eo-form-help-msg/eo-form-help-msg.component';
import { EoFormLabelComponent } from './form/shared/eo-form-label/eo-form-label.component';
import { EoMaxLengthCounterMsgComponent } from './form/shared/eo-max-length-counter-msg/eo-max-length-counter-msg.component';
import { EoValidationErrorMsgComponent } from './form/shared/eo-validation-error-msg/eo-validation-error-msg.component';
import { EoSplitCol } from './partial/eo-split-layout/eo-split-col.directive';
import { EoSplitLayoutComponent } from './partial/eo-split-layout/eo-split-layout.component';
import { PrimengModule } from './primeng.module';
import { EoBaseTableComponent } from './table/eo-base-table/eo-base-table.component';
import { EoTableRowExpansionComponent } from './table/eo-table-row-expansion/eo-table-row-expansion.component';
import { EoTableComponent } from './table/eo-table/eo-table.component';
import { EoBaseViewComponent } from './view/eo-base-view/eo-base-view.component';
import { EoCurrencyComponent } from './view/eo-currency/eo-currency.component';
import { EoDateComponent } from './view/eo-date/eo-date.component';
import { EoLabelComponent } from './view/eo-label/eo-label.component';
import { EoTextComponent } from './view/eo-text/eo-text.component';
import { EoViewPanelComponent } from './view/eo-view-panel/eo-view-panel.component';
import { EoSearchPanelComponent } from './partial/eo-search-panel/eo-search-panel.component';
import { EoSearchPageComponent } from './pages/eo-search-page/eo-search-page.component';
import { EoActionMenuButtonComponent } from './partial/eo-action-menu-button/eo-action-menu-button.component';
import { EoCheckboxComponent } from './form/eo-checkbox/eo-checkbox.component';
import { EoRadiobuttonComponent } from './form/eo-radiobutton/eo-radiobutton.component';
import { EoPaginatorComponent } from './partial/eo-paginator/eo-paginator.component';
import { EoTextAreaComponent } from './form/eo-textarea/eo-textarea.component';

@NgModule({
  declarations: [
    EoBaseFormControlComponent,
    EoValidationErrorMsgComponent,
    EoFormHelpMsgComponent,
    EoFormLabelComponent,
    EoMaxLengthCounterMsgComponent,
    EoInputComponent,
    EoTextAreaComponent,
    EoDropdownComponent,
    EoAutoCompleteComponent,
    EoFileUploadBaseComponent,
    EoFileUploadComponent,
    EoFileUploadAdvancedComponent,
    EoBaseViewComponent,
    EoTextComponent,
    EoCountryDropdownComponent,
    EoDateComponent,
    EoLabelComponent,
    EoCurrencyComponent,
    EoTableComponent,
    EoBaseTableComponent,
    EoDatePickerComponent,
    EoSpecialtyDropdownComponent,
    EoPickListComponent,
    EoUserDropdownComponent,
    EoTableRowExpansionComponent,
    EoFormPanelComponent,
    EoViewPanelComponent,
    EoFormComponent,
    EoSplitCol,
    EoSplitLayoutComponent,
    EoSearchPanelComponent,
    EoSearchPageComponent,
    EoActionMenuButtonComponent,
    EoCheckboxComponent,
    EoRadiobuttonComponent,
    EoPaginatorComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  exports: [
    EoInputComponent,
    EoTextAreaComponent,
    EoDropdownComponent,
    EoAutoCompleteComponent,
    EoCountryDropdownComponent,
    EoFormPanelComponent,
    EoFileUploadComponent,
    EoFileUploadAdvancedComponent,
    EoDateComponent,
    EoTextComponent,
    EoLabelComponent,
    EoCurrencyComponent,
    EoTableComponent,
    EoDatePickerComponent,
    EoSpecialtyDropdownComponent,
    EoPickListComponent,
    EoUserDropdownComponent,
    EoTableRowExpansionComponent,
    EoViewPanelComponent,
    EoFormComponent,
    EoSplitCol,
    EoSplitLayoutComponent,
    EoSearchPanelComponent,
    EoSearchPageComponent,
    EoActionMenuButtonComponent,
    EoCheckboxComponent,
    EoRadiobuttonComponent,
    EoPaginatorComponent
  ],
})
export class NgxEoWebComponentsModule {}
